import { render } from "./PitchHanga.vue?vue&type=template&id=8b7b94ce"
import script from "./PitchHanga.vue?vue&type=script&lang=js"
export * from "./PitchHanga.vue?vue&type=script&lang=js"

import "./PitchHanga.vue?vue&type=style&index=0&id=8b7b94ce&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__